import { render, staticRenderFns } from "./RankNormalItem.vue?vue&type=template&id=82e48e62"
import script from "./RankNormalItem.vue?vue&type=script&lang=js"
export * from "./RankNormalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports